import { HierarchicalItem } from '@wix/editor-platform-sdk-types';
import {
  NormalizedData,
  SectionsItems,
} from '@wix/editor-platform-host-integration-apis';

import { updateNestedObjectValue } from './updateNestedObjectValue';

export const addSectionsItemsData = (
  sectionId: string,
  accumulator: NormalizedData,
  data: HierarchicalItem[] = [],
): NormalizedData => {
  const sectionIndex = data.findIndex(({ id }) => id === sectionId);

  if (accumulator.sectionsWithItems[sectionId] || sectionIndex === -1) {
    return accumulator;
  }

  return updateNestedObjectValue<NormalizedData, SectionsItems>(
    accumulator,
    ['sectionsWithItems', sectionId],
    (sectionIdData) => ({
      ...sectionIdData,
      ...data[sectionIndex],
      unCategorizedItems: [],
      categoriesWithItems: {},
    }),
  );
};
